// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q2/2022greening/controller.php?enews=';
const token =
  'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vZGV2YXBpLmNxY2IuY29tL2FwaS91c2VyL2xvZ2luIiwiaWF0IjoxNjMxMTU1MTU4LCJleHAiOjE2MzExNTUyMTgsIm5iZiI6MTYzMTE1NTE1OCwianRpIjoidTFRMEJBam5GMDl2a1p1VSIsInN1YiI6ODc1MzYzLCJwcnYiOiI4NjY1YWU5Nzc1Y2YyNmY2YjhlNDk2Zjg2ZmE1MzZkNjhkZDcxODE4In0.droYDhfvZ6y2UZ-w8x_WscBeFqeY5C3WQGFcC69Lv5E';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};
// 列表
export const getlist = () => {
  return http.get(`${urlPrefix}vote-list`, {
    headers: {},
  });
};
// 用户信息
export const getUserInfo = () => {
  return http.get(`${urlPrefix}user-info`, {
    headers: {},
  });
};
export const getRankList = (date: any, page: any) => {
  return http.get(`${urlPrefix}rank&time=${date}&page=${page}`, {
    headers: {},
  });
};

export const getScore = (
  state: any,
  answerId: any,
  id: any,
  isTrue: any,
  time: any,
  answerTime: any,
) => {
  const data = {
    state,
    answer_id: answerId,
    id,
    true: isTrue,
    answer_time: answerTime,
    time,
  };

  return http.post(`${urlPrefix}score`, qs.stringify(data), {
    headers: {},
  });
};

export const getOneRank = () => {
  return http.get(`${urlPrefix}one-rank`, {
    headers: {},
  });
};

export { getBaseInfo, getNews, getRule };
